var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',{staticClass:"toast-button toast-button--bottom",class:{
    'toast-button--pulsing': _vm.pulsing,
  },attrs:{"type":"primary","disabled":_vm.loading,"loading":_vm.loading},on:{"click":function($event){return _vm.restore()}}},[_c('i',{staticClass:"button__icon iconoir-undo"}),_vm._v("\n  "+_vm._s(_vm.$t('restoreToast.restore', {
      type: _vm.$t('trashType.' + _vm.toast.data.trash_item_type),
    })))])
}
var staticRenderFns = []

export { render, staticRenderFns }